// Import the modal action types to be used
import { OPEN_MODAL, CLOSE_MODAL } from "../actions/modalActionTypes";


// Define the initial state of the modal
const initialState = {
    isModalVisible: false,
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_MODAL:
            return {
                ...state,
                isModalVisible: true,
            };
        case CLOSE_MODAL: 
            return {
                ...state,
                isModalVisible: false,
            };
        default :
            return state;
    }
};


export default modalReducer;